package com.gsb.vyapar.bhagya.interactor.util

import com.gsb.vyapar.bhagya.datasource.preference.Preference
import com.gsb.vyapar.bhagya.domain.Categories
import com.gsb.vyapar.bhagya.domain.Categories.D.Category
import com.gsb.vyapar.bhagya.domain.SubCategories.D.SubCategory
import com.gsb.vyapar.bhagya.domain.*
import com.gsb.vyapar.bhagya.domain.encodeSubCategoriesString
import com.gsb.vyapar.bhagya.interactor.manager.StateManager.getState
import com.gsb.vyapar.bhagya.interactor.manager.StateManager.updateState
import com.gsb.vyapar.bhagya.presentation.dialog.Dialogs
import com.gsb.vyapar.bhagya.presentation.dialog.uistate.DialogUiState

fun showLoading() {
    updateState(getState().copy(loadingUiState = DialogUiState()))
}

fun hideLoading() {
    updateState(getState().copy(loadingUiState = null))
}

fun showError(error: String) {
    updateState(getState().copy(errorUiState = DialogUiState(dialogType = Dialogs.Error, message = error)))
}

fun hideError() {
    updateState(getState().copy(errorUiState = null))
}

fun showSuccess(message: String) {
    updateState(getState().copy(successUiState = DialogUiState(dialogType = Dialogs.Success, message = message)))
}

fun hideSuccess() {
    updateState(getState().copy(successUiState = null))
}

fun saveConfig(config: Map<String, Int>) {
    val oldConfig = getState().config.decodeConfigString()
    val newConfig = Config(v = oldConfig.v, Config.D(config))
    updateState(getState().copy(config = newConfig.encodeConfigString()))
    Preference.config = getState().config
}

fun saveCategories(categories: List<Category>) {
    val oldCategories = getState().categories.decodeCategoriesString()
    val newCategories = Categories(v = oldCategories.v, Categories.D(categories))
    updateState(getState().copy(categories = newCategories.encodeCategoriesString()))
    Preference.categories = getState().categories
}

fun saveSubCategories(subCategories: List<SubCategory>) {
    val oldSubCategories = getState().subCategories.decodeSubCategoriesString()
    val newSubCategories = SubCategories(v = oldSubCategories.v, SubCategories.D(subCategories))
    updateState(getState().copy(subCategories = newSubCategories.encodeSubCategoriesString()))
    Preference.subCategories = getState().subCategories
}

fun saveInfo(info: Map<String, String>) {
    val oldInfo = getState().info.decodeInfoString()
    val newInfo = Info(v = oldInfo.v, Info.D(info))
    updateState(getState().copy(info = newInfo.encodeInfoString()))
    Preference.info = getState().info
}
